import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { ProjectService } from '../_services/project.service';
import { User } from '../_models/user.model';
import { ConfirmDialogService } from '../_common/confirm.dialog';
import { Slug } from 'ng2-slugify';

@Component({
    selector: 'app-project',
    templateUrl: './project.component.html',
    styleUrls: ['./project.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class ProjectComponent implements OnInit {

    private slugify: Slug;

    private busy: boolean;
    private sidebarBusy: boolean;

    private projectId: number;
    private project: any;
    private projectFiles: any;
    private fileTypes: any;
    private projectStatuses: any = [{ Id: 0, Title: 'Bidding', }, { Id: 1, Title: 'On-going' }, { Id: 2, Title: 'Completed' }];

    private portId: number;
    private slug: string;
    private selectedYear: number;
    private mapType: string;
    private facilityId: number;
    private facilitySlug: string;

    private user: User;

    constructor(private projectService: ProjectService, private activatedRoute: ActivatedRoute, private confirmDialog: ConfirmDialogService, private authService: AuthService) {
        this.slugify = new Slug('');

        let params = activatedRoute.snapshot.params;
        this.projectId = params['projectId'];
        this.projectFiles = {};
        this.fileTypes = {
            'doc': 'Documents',
            'docx': 'Documents',
            'ppt': 'Presentations',
            'pptx': 'Presentations',
            'xls': 'Spreadsheets',
            'xlsx': 'Spreadsheets',
            'jpg': 'Images',
            'png': 'Images',
            'bmp': 'Images',
            'pdf': 'PDF',
            '?': 'Unknown'
        };
    }

    ngOnInit() {
        this.busy = true;
        this.user = this.authService.getUser();

        this.projectService.getProject(this.projectId)
            .subscribe((response) => {
                let result = response.json().Result;
                this.project = result.Project;
                this.busy = false;

                this.portId = this.project.Port.Id;
                this.slug = this.slugify.slugify(this.project.Port.Title);
                this.selectedYear = this.project.Year;
                this.mapType = 'navigation';
                if (this.project.Facility) {
                    this.mapType = this.project.Facility.MapType == 0 ? 'planning' : 'sounding';
                    this.facilityId = this.project.Facility.Id;
                    this.facilitySlug = this.slugify.slugify(this.project.Facility.Title);
                }

                this.project.Status = this.projectStatuses.find((status) => status.Id == this.project.Status);

                if (this.project.Files) {
                    this._redistributeFiles();
                }

                this.calculatePermissions();
            }, (error) => {
                this.busy = false;
            });
    }


    private uploadFile(files: File[]) {
        // Check if more than one file
        let file = files.pop();
        let shouldUpload = false;

        // Check if filename exists
        if (this.project.Files) {
            let existingFile = this.project.Files.find((projectFile) => {
                return (projectFile.Filename.toLowerCase() == file.name.toLowerCase());
            });

            if (existingFile != null) {
                // Show a dialog
                let message = existingFile.Filename + '\nContinuing will overwrite files with existing filename. Would you like to proceed?';
                this.confirmDialog.confirm('Overwrite confirmation', message)
                    .subscribe((shouldContinue) => {
                        if (shouldContinue) {
                            this.sidebarBusy = true;

                            this.projectService.uploadProjectFile(this.projectId, file)
                                .subscribe(response => {
                                    let result = response.json().Result;
                                    let newFile = result.File;

                                    this.sidebarBusy = false;

                                    if (this.project.Files == null) this.project.Files = [];

                                    this._redistributeFiles();
                                });
                        }
                    });

                return;
            }
        }

        this.projectService.uploadProjectFile(this.projectId, file)
            .subscribe(response => {
                let result = response.json().Result;
                let newFile = result.File;

                this.sidebarBusy = false;

                if (this.project.Files == null) this.project.Files = [];

                this.project.Files.push(newFile);
                this._redistributeFiles();
            }, response => {
                
            });
    }

    private deleteFile(file: any) {
        let id = file.Id;
        this.projectService.deleteProjectFile(file.Id);

        let message = file.Filename + '\nContinuing will delete this file. Would you like to proceed?';
        this.confirmDialog.confirm('Delete confirmation', message)
            .subscribe((shouldContinue) => {
                if (shouldContinue) {
                    this.sidebarBusy = true;

                    this.projectService.deleteProjectFile(id)
                        .subscribe(response => {
                            this.project.Files = this.project.Files.filter((existingFile) => {
                                return existingFile.Id != id;
                            });

                            this.sidebarBusy = false;

                            this._redistributeFiles();
                        });
                }
            });

        return;
    }

    private _redistributeFiles() {
        this.projectFiles = {};

        this.project.Files.forEach((file) => {
            let lastIndexOfDot = file.Filename.lastIndexOf('.') + 1;
            let ext: string = '?';

            if (lastIndexOfDot != -1) {
                ext = file.Filename.substring(lastIndexOfDot).toLowerCase();
            }

            let group = this.fileTypes[ext];
            if (group == null) {
                ext = '?';
                group = this.fileTypes[ext];
            }

            if (this.projectFiles[group] == null) {
                this.projectFiles[group] = [];
            }

            this.projectFiles[group].push(file);
        });

        for (let key in this.projectFiles) {
            var group = this.projectFiles[key];
            group.sort((a, b) => {
                var nameA = a.Filename.toUpperCase(); // ignore upper and lowercase
                var nameB = b.Filename.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            });
        }

        //Object.entries(this.projectFiles).forEach(([key, value]) => {
        //    console.log(value);
        //    //value.sort((a, b) => {
        //    //    var nameA = a.Filename.toUpperCase(); // ignore upper and lowercase
        //    //    var nameB = b.Filename.toUpperCase(); // ignore upper and lowercase
        //    //    if (nameA < nameB) {
        //    //        return -1;
        //    //    }
        //    //    if (nameA > nameB) {
        //    //        return 1;
        //    //    }

        //    //    // names must be equal
        //    //    return 0;
        //    //});
        //});
    }

    private isAllowed: any = {};
    
    private calculatePermissions() {
        let portOfficeId = this.project.PortManagementOffice.Id + '';
        switch (this.user.Role) {
            case 'GlobalAdministrator':
                this.isAllowed['edit'] = true;
                this.isAllowed['files'] = true;
                break;
            case 'PPAExecutive':
                break;
            case 'PMOAdmin':
                if (this.user.OfficeIds != null && this.user.OfficeIds.indexOf(portOfficeId) != -1) {
                    this.isAllowed['edit'] = true;
                    this.isAllowed['files'] = true;
                }
                break;
            case 'PPAPlanning':
                this.isAllowed['edit'] = this.mapType === 'planning';
                this.isAllowed['files'] = this.mapType === 'planning';
                break;
            case 'PPADredging':
                this.isAllowed['edit'] = this.mapType === 'navigation' || this.mapType === 'sounding';
                this.isAllowed['files'] = this.mapType === 'navigation' || this.mapType === 'sounding';
                break;
            case 'PPAPortConstruction':
                this.isAllowed['edit'] = this.mapType === 'planning';
                this.isAllowed['files'] = this.mapType === 'planning';
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./Angular/app/project/project.component.ts